// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-circle{position:absolute;left:58%;top:96%;margin-left:-3rem;margin-top:-3rem;width:2rem;height:2rem;border:solid 4px #ffffff;border-top:solid 4px #6e87ff;border-radius:50%;animation-name:rotation;animation-duration:2s;animation-iteration-count:infinite;animation-timing-function:linear}@keyframes rotation{25%{transform:rotate(90deg)}50%{transform:rotate(180deg)}75%{transform:rotate(270deg)}100%{transform:rotate(360deg)}}\n", ""]);
// Exports
module.exports = exports;



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js!./node_modules/sass-loader/dist/cjs.js!./src/components/ForgotPwd/ForgotPwd.scss
// module id = 951
// module chunks = 0